<template>
    <SplideSlide>
        <div class="sr-only" aria-live="polite">{{ accessibilityAnnouncement }}</div>
        <h2 class="slide_head lg:text-2xl text-xl text-white">
            {{ full_date(day.date) }}
        </h2>
        <div class="relative" v-if="!verifyExcludeDay(day.date)">
            <div v-if="$page.props.is_login && checkLengthOfOptions()" class="absolute bottom-3 right-3">
                <button @click="showPhotoChangePopUp()" :tabindex="isActive ? 0 : -1"
                    class="text-black bg-white rounded-full w-8 h-8 flex justify-center items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" data-slot="icon" class="w-6 h-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M6.827 6.175A2.31 2.31 0 0 1 5.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 0 0-1.134-.175 2.31 2.31 0 0 1-1.64-1.055l-.822-1.316a2.192 2.192 0 0 0-1.736-1.039 48.774 48.774 0 0 0-5.232 0 2.192 2.192 0 0 0-1.736 1.039l-.821 1.316Z" />
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M16.5 12.75a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0ZM18.75 10.5h.008v.008h-.008V10.5Z" />
                    </svg>
                </button>
            </div>
            <img :src="activeOptionImage" :original="activeOptionImage.replace('_resize', '')"
                @error="$helpers.replaceByDefault" :alt="'Image for ' + (activeOption ? getOptionName(activeOption) : 'Option')"
                class="xl:h-[550px] sm:h-[400px] h-[300px] object-cover object-center w-full" />
        </div>
        <div class="relative w-full h-full bg-gray-200 flex justify-center items-center text-3xl font-semibold" v-else>
            Not In Session
        </div>


        <!-- <div v-if="userLoginCheck" class="absolute top-[84px] right-3"> -->


        <div class="content-section w-full 2xl:px-40 md:px-12 py-6 px-4 bg-[#3f3f3f] content_section_new"
            v-if="!verifyExcludeDay(day.date)">
            <div class="full_div">
                <div class="md:flex justify-between gap-5">
                    <div class="md:w-1/3 w-full md:mb-0 mb-5">
                        <div v-for="(group, gIndex) in groupedActiveRecipes" :key="gIndex" role="group" :aria-label="group.category">
                            <h6 class="content-section--title text-[#ffc919] text-base leading-4 uppercase font-bold mt-3 first:mt-0">
                                {{ group.category }}
                            </h6>
                            <div class="content-section--option-detail w-full text-[#fff]" v-for="recipe in group.recipes" :key="recipe.id">
                                <button class="content-section--description  xl:text-xl leading-6 capitalize text-lg cursor-pointer text-left w-full hover:underline focus:ring-2 focus:ring-[#0094cc] outline-none"
                                    @click="recipeIndex = recipe.originalIndex" :class="recipe.originalIndex === recipeIndex ? 'text-[#0094cc]' : ''"
                                    :aria-pressed="recipe.originalIndex === recipeIndex" :tabindex="isActive ? 0 : -1">
                                    {{ recipe.show_name }} <span
                                        class="bg-white text-[#3f3f3f] p-[3px] rounded-md ml-1 sm:text-lg font-bold text-base"
                                        v-if="recipe?.allergens_name && recipe?.allergens_name != ''"
                                        aria-label="Contains Allergens">A</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <SingleDaySlideItemSingle :product="activeOption" :recipeIndex="recipeIndex"
                        :userLoginCheck="userLoginCheck" :isActive="isActive" />


                </div>
            </div>
        </div>
        <div class="content-pagination w-full py-2 flex justify-center items-center bg-[#385592] peginaction_coustam"
            v-if="optionLength > 1 && !verifyExcludeDay(day.date)">

            <div class="flex items-center gap-2 justify-center">
                <button :disabled="activePage == 1" @click="goToPage(activeIndex - 1)" class="cursor-pointer"
                    v-if="optionLength > 1 && activePage > 1" aria-label="Previous Option" :tabindex="isActive ? 0 : -1">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" class="fill-white prev-page" width="14"
                        height="14" focusable="false">
                        <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z">
                        </path>
                    </svg>
                </button>


                <div class="flex items-center gap-2 justify-center">
                    <button v-for="(page, i) in optionLength" @click="goToPage(i)"
                        class="text-white mr-0 px-3 py-2 rounded-full w-7 h-7 flex justify-center items-center hover:bg-[#0094cc]"
                        :class="{ 'bg-[#0094cc]': i == activeIndex }"
                        :aria-label="'Go to ' + getOptionName(day.options[i])" :tabindex="isActive ? 0 : -1">
                        {{ page }}
                    </button>
                </div>

                <button :disabled="page < day.options.length" @click="goToPage(activeIndex + 1)" class="cursor-pointer"
                    v-if="optionLength > 1 && activeIndex < optionLength - 1" aria-label="Next Option" :tabindex="isActive ? 0 : -1">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" class="fill-white" width="14" height="14"
                        focusable="false">
                        <path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z">
                        </path>
                    </svg>
                </button>
            </div>
        </div>
    </SplideSlide>

    <ChangePhotoOnFront ref="ChangePhotoOnFront" :products="products" :userLoginCheck="userLoginCheck"
        @closeCalendarPopUp="closePopUp" />
</template>

<script>
var moment = require("moment");
import ChangePhotoOnFront from "@/Pages/ParentPortal/Home/ChangePhotoOnFront";

import SingleDaySlideItemSingle from "@/Pages/ParentPortal/Home/SingleDaySlideItemSingle";

export default {
    components: {
        ChangePhotoOnFront,
        SingleDaySlideItemSingle
    },

    props: {
        day: {
            type: Object,
        },
        menuCycle: {
            type: [Object],
            default: () => null,
        },
        userLoginCheck: {
            type: Boolean,
            default: () => false,
        },
        products: {
            type: [Object],
            default: () => null,
        },
        excludeDays: {
            type: [Object],
            default: () => null,
        },
        isActive: {
            type: Boolean,
            default: () => false,
        },
    },
    data() {
        return {
            moment: moment,
            activeIndex: 0,
            maxVisiblePages: 4,
            activeRecipe: 0,
            recipeIndex: -1,
            accessibilityAnnouncement: ""
        };
    },
    computed: {

        optionLength() {
            console.log("option length", this.day.options.length || 0);
            return this.day.options.length || 0;
        },
        activeOption() {
            return this.day.options.length > 0
                ? this.day.options[this.activeIndex]
                : false;
        },
        activeOptionImage() {

            if (this.optionLength) {
                if (this.activeOption && this.activeOption.photo_store_path) {
                    return (
                        this.$page.props.storage_image_url +
                        this.activeOption.photo_store_path + '_resize'
                    );
                }
                return this.$page.props.asset_url + "/images/pizza-icon-image.jpg";
            }
            return this.$page.props.asset_url + "/images/no-food-sign2.jpg";
        },
        activeRecipes() {
            if (this.activeOption && this.activeOption.recipes) {
                return this.sortedRecipeArray(this.activeOption.recipes);
            }
            return [];
        },
        groupedActiveRecipes() {
            const sorted = JSON.parse(JSON.stringify(this.activeRecipes));
            const groups = [];
            let currentGroup = null;
            sorted.forEach((recipe, index) => {
                if (!currentGroup || currentGroup.category !== recipe.category) {
                    currentGroup = { category: recipe.category, recipes: [] };
                    groups.push(currentGroup);
                }
                recipe.originalIndex = index;
                currentGroup.recipes.push(recipe);
            });
            return groups;
        },
        activePage() {
            return this.activeIndex + 1;
        },
        visiblePageNumbers() {
            const firstPage = 1;
            const lastPage = this.optionLength;
            const maxLinks = 4; // Show the first two and last two page links

            return [1, 2, "...", lastPage - 1, lastPage];
        },
    },
    watch: {
        recipeIndex(newVal) {
            if (newVal !== -1) {
                const recipe = this.activeRecipes[newVal];
                if (recipe) {
                    this.accessibilityAnnouncement = `Now showing nutritional information for ${recipe.show_name}`;
                }
            } else if (this.activeOption) {
                this.accessibilityAnnouncement = `Now showing nutritional information for ${this.getOptionName(this.activeOption)}`;
            }
        }
    },
    methods: {

        sortedRecipeArray(recipe_arrays) {
            // console.log("recipe_arrays", recipe_arrays);
            let a = _.orderBy(recipe_arrays, 'name', 'asc');
            a = _.orderBy(a, 'category_sort', 'asc');
            // console.log("recipe_arrays a", recipe_arrays);
            return a;
        },
        getOptionName(mc) {
            if (!mc) return "Option";
            if (mc.name == "") {
                return "Option " + mc.sort_order;
            } else {
                return mc.name;
            }
        },

        verifyExcludeDay(current_date) {
            // console.log('excludeDays');
            if (this.excludeDays) {
                var new_date = moment(current_date, 'MM-DD-YYYY').format('MM/DD/YYYY');
                // var new_date = moment(current_date).format('MM/DD/YYYY');
                let obj = this.excludeDays.find(o => o.date === new_date);
                if (obj) {
                    return true;
                } else {
                    return false;
                }
            }
            return false;

        },

        checkLengthOfOptions() {
            if (this.optionLength > 0) {
                return true;
            }
            return false;
        },

        full_date(value) {
            if (value) {
                let date;
                // Check if the browser is Safari
                const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                if (isSafari) {
                    // Safari requires the date string to be in YYYY/MM/DD format
                    const parts = String(value).split('-');
                    date = new Date(`${parts[0]}/${parts[1]}/${parts[2]}`);
                } else {
                    date = new Date(value);
                }
                const options = { weekday: 'long', month: 'long', day: 'numeric' };
                return date.toLocaleDateString('en-US', options);
            }
        },

        showPhotoChangePopUp() {
            this.$refs.ChangePhotoOnFront.showPhotoChangePopUp(this.activeOption);
        },

        updatePage(page) {
            if (this.activeIndex != page - 1) {
                this.activeIndex = page - 1;
            }
        },
        goTo(type) {
            // if (type == "prev" && this.activeIndex > 0) {
            //     this.activeIndex--;
            // }
            // if (type == "next" && this.activeIndex < this.optionLength - 1) {
            //     this.activeIndex++;
            // }
        },
        goToPage(page) {
            console.log("page", page);
            console.log("length", this.optionLength);
            this.recipeIndex = -1;
            if (page >= 0 && page <= this.optionLength - 1) {
                this.activeIndex = page;
                this.accessibilityAnnouncement = `Showing ${this.getOptionName(this.day.options[page])}`;
            }
        },
        shouldShowPage(pageindex) {
            if (this.optionLength > 4) {
                const totalLength = this.optionLength;
                // const prevShow = currentIndex - 2;
                // const nextShow = currentIndex + 2;

                if (
                    pageindex >= this.activePage - 2 &&
                    pageindex <= this.activePage + 2
                ) {
                    return true;
                }

                if (pageindex == this.optionLength - 1) {
                    return true;
                }

                if (pageindex == this.activePage + 3) {
                    return "betweenpage"; // You can return any other value you prefer
                }
            }
        },
    },
};
</script>

<style scoped>
.content-section--option-data {
    color: #fff;
}

.prev-page {
    transform: scaleX(-1);
}

svg.fill-white {
    fill: #fff;
}

ul.splide__list li.splide__slide {
    background-color: #3f3f3f;
}

ul.splide__list li.splide__slide.is-active.is-visible {
    border-radius: 10px;
    overflow: hidden;
}

.peginaction_coustam {
    position: absolute;
    bottom: 0;
}

ul.splide__list li.splide__slide {
    position: relative;
    padding-bottom: 45px !important;
}
</style>
